import { css } from "@emotion/react";

import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const itemStyle = ({ borderRadiusV2, colorsV2 }: ExactTheme) =>
  css({
    overflow: "hidden",
    marginTop: 1,
    borderTopLeftRadius: borderRadiusV2.primary,
    borderTopRightRadius: borderRadiusV2.primary,
    color: colorsV2.grey[900],

    "&:not(:first-of-type)": {
      marginTop: 15,
    },

    "&:focus-within": {
      position: "relative",
      zIndex: 1,
    },
  });

export const triggerStyle = ({ colorsV2 }: ExactTheme) =>
  css({
    padding: 10,
    position: "relative",
    display: "flex",
    border: "none",
    backgroundColor: "transparent",
    width: "100%",
    height: 40,
    flex: 1,
    gap: 10,
    alignItems: "center",
    transition: "background-color 0.3s",
    borderBottom: `1px solid ${colorsV2.grey[100]}`,
  });

export const dateLabel = (theme: ExactTheme) =>
  css({
    fontSize: theme.fontSizesV2.body,
    fontWeight: theme.fontWeights.normal,
  });

export const typeLabel = (theme: ExactTheme) =>
  css({
    marginRight: "10px",
    fontSize: theme.fontSizesV2.body,
    fontWeight: theme.fontWeights.semibold,
  });
